import {Component} from 'react';
import h from 'react-hyperscript';
import Image from 'Components/Image/Image';
import {p} from 'Components/Typography/Typography';

class RemainingProducts extends Component {
  render() {
    if (this.props.isExpanded) {
      const flex = 'flex--space-between--all';
      const classes = `remaining-product ${flex} margin-bottom--sm`;

      return (
        h('div', {
          className: 'remaining-products margin-top--md',
        }, [
          this.props.totalProducts.map((prod, i) => {
            if (this.props.remainingProducts.includes(prod.id)) {
              return (
                h('div', {
                  key: `prod--${i}`,
                  id: `remaining-product--${prod.id}`,
                  className: classes,
                  dataproduct: prod.id,
                  databucket: this.props.bucket,
                  onClick: (e) => {
                    this.props.handleAddToBucket(e);
                  },
                }, [
                  h('div', {
                    className: 'flex',
                  }, [
                    h(Image, {
                      src: prod.icon,
                      srcset: {
                        standard: prod.icon,
                        retina: prod.icon_2x,
                      },
                      className: 'padding-right--micro product-icon',
                    }, null),
                    h(p, null, prod.title),
                  ]),
                  h('span', {
                    className: 'material-icons text--grey',
                  }, 'add'),
                ])
              );
            }
            return null;
          }),
          h('span', {
            className: 'material-icons text--grey text--center flex--center',
            onClick: () => {
              this.props.closeRemainingProducts(this.props.bucket);
            },
          }, 'close'),
        ]
        )
      );
    } else {
      return null;
    }
  }
}

export default RemainingProducts;
